import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_da98dbcd-f751-4482-bd4e-a7e20426ba71/artifacts/tm6wbpvj_CD8D187A-3FEA-430F-A897-685C7F8A2178.png";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password }, { withCredentials: true });
      localStorage.setItem("admin_user", JSON.stringify(res.data.admin));
      toast.success("Signed in");
      navigate("/admin/dashboard");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "var(--bg-primary)" }} data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <img src={LOGO_URL} alt="Green Routes" className="h-10 mx-auto mb-6 logo-blend" />
          <div className="inline-flex items-center justify-center w-12 h-12 mb-4" style={{ background: "rgba(15,50,33,0.06)", border: "1px solid rgba(15,50,33,0.15)" }}>
            <Lock size={20} style={{ color: "var(--accent)" }} />
          </div>
          <h1 className="text-2xl tracking-tight mb-1" style={{ color: "var(--text-primary)" }}>Admin Portal</h1>
          <p className="text-sm" style={{ color: "var(--text-tertiary)" }}>Authorized access only</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-xs uppercase tracking-[0.15em] mb-2" style={{ color: "var(--text-tertiary)" }}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="input-admin-email"
              className="w-full bg-transparent border-b py-3 px-0 text-base outline-none"
              style={{ borderColor: "var(--border)", color: "var(--text-primary)" }}
              required
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.15em] mb-2" style={{ color: "var(--text-tertiary)" }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="input-admin-password"
              className="w-full bg-transparent border-b py-3 px-0 text-base outline-none"
              style={{ borderColor: "var(--border)", color: "var(--text-primary)" }}
              required
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="btn-admin-login"
            className="w-full py-3 text-sm font-semibold tracking-wide"
            style={{ background: "var(--accent)", color: "#FFFFFF" }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
